import { useState } from "react";
import { Trash2 } from "lucide-react";
import FloatingBubble from "../FloatingBubble";
import ColorPopover from "../ColorPopover";
import "./Bubbles.css";

export default function DividerBubble({ anchorEl, iframeEl, onClose, onChange }) {
  const [color, setColor] = useState(anchorEl.style.borderTopColor || "#e2e8f0");
  const [thickness, setThickness] = useState(parseInt(anchorEl.style.borderTopWidth) || 1);
  const [width, setWidth] = useState(parseInt(anchorEl.style.width) || 100);
  const [colorOpen, setColorOpen] = useState(false);

  const apply = (patch) => {
    const next = { color, thickness, width, ...patch };
    if (patch.color !== undefined) setColor(patch.color);
    if (patch.thickness !== undefined) setThickness(patch.thickness);
    if (patch.width !== undefined) setWidth(patch.width);
    anchorEl.style.border = "none";
    anchorEl.style.borderTop = `${next.thickness}px solid ${next.color}`;
    anchorEl.style.width = `${next.width}%`;
    anchorEl.style.marginLeft = next.width === 100 ? "0" : "auto";
    anchorEl.style.marginRight = next.width === 100 ? "0" : "auto";
    onChange();
  };

  const del = () => { anchorEl.parentNode?.removeChild(anchorEl); onChange(); onClose(); };

  return (
    <FloatingBubble anchorEl={anchorEl} iframeEl={iframeEl} label="Divider" onClose={onClose}>
      <div className="bubble-color-popover-wrap">
        <button type="button" className="bubble-color-trigger" onClick={() => setColorOpen((v) => !v)}>
          <span className="bubble-color-swatch" style={{ background: color }} />
          Color
        </button>
        {colorOpen && <ColorPopover value={color} onChange={(c) => apply({ color: c })} onClose={() => setColorOpen(false)} />}
      </div>
      <div className="bubble-field">
        <label>Thickness (px)</label>
        <input type="number" min={1} max={10} value={thickness} onChange={(e) => apply({ thickness: parseInt(e.target.value) || 1 })} />
      </div>
      <div className="bubble-field">
        <label>Width (%)</label>
        <input type="number" min={10} max={100} value={width} onChange={(e) => apply({ width: parseInt(e.target.value) || 100 })} />
      </div>
      <div className="bubble-actions">
        <button type="button" className="bubble-btn danger" onClick={del}><Trash2 size={12} /> Delete</button>
      </div>
    </FloatingBubble>
  );
}
